module.exports = __webpack_public_path__ + "img/deliver-img-4-3.5a7e99c1.png";